import { Utils } from "@crispico/foundation-react";
import { AbstractItemRenderer } from "./AbstractItemRenderer";

export interface ProposedTimeSlotItem {
    startTime: number,
    endTime: number,
    type: { id: number, name: string, color: number },
    inactivityType: { id: number, name: string, color: string, duration: number },
    resource: { id: number, identifier: string },
    equipmentType: { id: number, name: string }
}

export class ProposedTimeSlotItemRenderer extends AbstractItemRenderer<ProposedTimeSlotItem> {

    protected get entityName(): string {
        return "ProposedTimeSlot";
    }

    getName(): string {
        return this.propsCasted.entity.type?.name || this.propsCasted.entity.inactivityType?.name;
    }

    getTitle(): string | JSX.Element {
        return _msg("ProposedTimeSlot.title.label", this.getName());
    }

    getColor(): string {
        // gray w/ alpha to apply opacity exclusively to the background, leaving the text fully visible.
        return Utils.getRGBAColor("#808080", 0.2);
    }

    getStyle() {
        const style = {
            ...super.getStyle(),
            opacity: 0.75,
            border: '2px dashed gray'
        };
        return style;
    }

    getBackgroundGradient() {
        return this.getColor();
    }

    getGlowOnHoverClassName() {
        return '';
    }
}
